/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import {put, takeEvery } from '@redux-saga/core/effects';
import { setToasNotificationSuccess, setToasNotificationFailure } from '../actions/ui-notification.action';
import { SET_UI_TOAST_NOTIFICATION, SetUiToastNotification } from 'src/types/ui-notification.type';
import { NotificationMode } from 'src/constants/theme.constant';

function* onSetToastNotification(toastData:SetUiToastNotification) {
  try {
    const toastNotification = {
      ...toastData.payload,
      mode: NotificationMode.Toast,
    }
    yield put(setToasNotificationSuccess(toastNotification));
  } catch (err) {
    yield put(setToasNotificationFailure(err));
  }
}

export function* watchOnSetToastNotification() {
  yield takeEvery(SET_UI_TOAST_NOTIFICATION, onSetToastNotification);
}
